import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { thousandNumberSeperator } from '../../utils/format';
import { trackEvent } from '../../utils/gtm';
import { Step } from '../../models/Step';
import { animateScroll } from 'react-scroll';
import { ApplicationFormStateContext } from '../../state/applicationFormState';
import * as Sentry from "@sentry/react";

export const Amounts = [300000, 200000, 150000, 100000, 75000, 50000];

const AmountStep: React.FunctionComponent = () => {
  const [,dispatch] = useContext(ApplicationFormStateContext);
  const navigate = useNavigate();
  

  useEffect(() => {
    trackEvent({eventName: 'step_load', data: { step: 'Amount' } });
    dispatch({ type: 'set_step', step: Step.Amount });
    animateScroll.scrollToTop();
  }, []);

  useEffect(() => {}, [Amounts]);

  const handleClick = (amount: number) => {
    dispatch({ type: 'set_amount', values: amount });
    navigate(`/produkt/${amount}`);
  };
  
  const handleClick_Other = () => {
    navigate('/andet-beloeb');
  };

  return (
    <>
      <h2>Vælg beløb - hvor meget vil du låne?</h2>
      <h3>Få et lån uden udbetaling eller pant, gennemfør ansøgning og får svar på <span className='whitespace-nowrap'>5 min.</span></h3>
      <div className="mt-5">
        {Amounts.map((amount, index) => (
          <div 
            className="w-1/2 md:w-1/3 inline-block p-2"
            key={amount + index}>
            <button
              className="btn-choice"
              onClick={() => handleClick(amount)}
            >
              {thousandNumberSeperator(amount)} kr.
            </button>
          </div>
        ))}
        <div className="w-1/2 md:w-1/3 inline-block p-2">
          <button onClick={handleClick_Other} className="btn-choice w-full h-16">Andet...</button>
        </div>
      </div>
    </>
  );
};

export default AmountStep;